import { createContext, useContext, useEffect, useState } from "react";
import { fr } from "./content.fr";
import { en } from "./content.en";

// FR = source de vérité. EN = brouillon fonctionnel à valider par le client.
// Tout le copy vit dans content.fr.js / content.en.js.
export const dict = { fr, en };

const LangContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("aelvir-lang") || "fr");
  useEffect(() => {
    localStorage.setItem("aelvir-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const toggle = () => setLang((l) => (l === "fr" ? "en" : "fr"));
  return (
    <LangContext.Provider value={{ lang, setLang, toggle, t: dict[lang] }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
